import { RouteRecordRaw } from "vue-router";
import ACCESS_ENUM from "@/access/accessEnum";

export const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "layout",
    redirect: "/home",
    meta: {
      title: "",
      hidden: false,
      icon: "BankOutlined",
    },
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import("../views/Home/index.vue"),
        meta: {
          title: "主页",
          hidden: false,
          icon: "RocketOutlined",
        },
      },
    ],
  },
  {
    path: "/genPicture",
    name: "genPicture",
    redirect: "/textToPic",
    meta: {
      title: "AI生图",
      hidden: false,
      icon: "PictureOutlined",
    },
    children: [
      {
        path: "/textToPic",
        // 修改 name，避免重复
        name: "textToPic",
        component: () => import("../views/Picture/TextToPicture.vue"),
        meta: {
          title: "文生图",
          hidden: false,
          icon: "PictureFilled",
        },
      },
      {
        path: "/enforcePic",
        name: "enforcePic",
        component: () => import("../views/Picture/EnforcePicture.vue"),
        meta: {
          title: "图像增强",
          hidden: false,
          icon: "PictureFilled",
        },
      },
    ],
  },
  // {
  //   path: "/genVideo",
  //   name: "genVideo",
  //   // 修正 redirect 位置
  //   redirect: "/sora",
  //   meta: {
  //     title: "AI视频",
  //     hidden: false,
  //     icon: "YoutubeOutlined",
  //   },
  //   children: [
  //     {
  //       path: "/sora",
  //       name: "sora",
  //       component: () => import("../views/Video/UseSora.vue"),
  //       meta: {
  //         title: "Sora",
  //         hidden: false,
  //         icon: "YoutubeFilled",
  //       },
  //     },
  //     {
  //       path: "/veo3",
  //       // 修改 name
  //       name: "veo3",
  //       component: () => import("../views/Video/UseSora.vue"),
  //       meta: {
  //         title: "Veo3",
  //         hidden: false,
  //         icon: "YoutubeFilled",
  //       },
  //     },
  //     {
  //       path: "/veo3point1",
  //       name: "veo3point1",
  //       component: () => import("../views/Video/UseSora.vue"),
  //       meta: {
  //         title: "Veo3.1",
  //         hidden: false,
  //         icon: "YoutubeFilled",
  //       },
  //     },
  //     {
  //       path: "/wan",
  //       name: "wan",
  //       component: () => import("../views/Video/UseSora.vue"),
  //       meta: {
  //         title: "Wan 2.5",
  //         hidden: false,
  //         icon: "YoutubeFilled",
  //       },
  //     },
  //   ],
  // },
  {
    path: "/index",
    name: "index-page", // 修改 name 避免与 children 混淆
    component: () => import("../views/Index/index.vue"),
    meta: {
      title: "接口广场",
      hidden: false,
      icon: "StarOutlined",
    },
  },
  {
    path: "/Manager",
    name: "api-manager", // 修改 name 避免与 children 混淆
    component: () => import("../views/manageAPI/index.vue"),
    meta: {
      title: "接口管理",
      hidden: false,
      icon: "ApartmentOutlined",
      access: ACCESS_ENUM.ADMIN,
    },
  },
  {
    path: "/mark",
    name: "mark", // 修改 name 避免与 children 混淆
    component: () => import("../views/MarkView.vue"),
    meta: {
      title: "Credit商城",
      hidden: false,
      icon: "ShopOutlined",
      access: ACCESS_ENUM.NOT_LOGIN, //
    },
  },
  {
    path: "/order",
    name: "order", // 修改 name 避免与 children 混淆
    component: () => import("../views/OrderView.vue"),
    meta: {
      title: "我的订单",
      hidden: false,
      icon: "AccountBookOutlined",
      access: ACCESS_ENUM.USER,
    },
  },
  {
    path: "/viewDetail",
    name: "detail-page", // 修改 name 避免与 children 混淆
    component: () => import("../views/Detail/index.vue"),
    meta: {
      title: "接口详情",
      hidden: true,
      icon: "StarOutlined",
      access: ACCESS_ENUM.USER,
    },
  },
  {
    path: "/login",
    name: "login", // 修改 name 避免与 children 混淆
    component: () => import("../views/Login/index.vue"),
    meta: {
      title: "登录",
      hidden: true,
      icon: "StarOutlined",
    },
  },
  // {
  //   path: "/message",
  //   name: "message", // 消息中心
  //   component: () => import("../views/MessageView.vue"),
  //   meta: {
  //     title: "我的消息",
  //     hidden: true,
  //     icon: "MessageOutlined",
  //   },
  // },
  {
    path: "/register",
    name: "register", // 修改 name 避免与 children 混淆
    component: () => import("../views/Register/index.vue"),
    meta: {
      title: "注册",
      hidden: true,
      icon: "StarOutlined",
    },
  },
  {
    path: "/userInfo",
    name: "userInfo", // 修改 name 避免与 children 混淆
    component: () => import("../views/Person/index.vue"),
    meta: {
      title: "个人信息",
      hidden: true,
      icon: "StarOutlined",
      access: ACCESS_ENUM.USER,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found", // 修改 name 避免与 children 混淆
    component: () => import("../views/404/index.vue"),
    meta: {
      title: "页面未找到",
      hidden: true,
      icon: "StarOutlined",
    },
  },
];
